import { Component, ElementRef, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { IPortalBanner } from 'src/app/models/portal.model';
import { AppState } from 'src/app/redux/app.state';
import { portalSettingsBanner } from 'src/app/redux/selectors/portal.selector';
import { LocalStorageKeyEnum, LocalStorageService } from 'src/app/services/local-storage/local-storage.service';
import { UserAuthenticationService } from 'src/app/services/user-authentication/user-authentication.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'bt-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class BannerComponent implements OnInit {
	private store = inject<Store<AppState>>(Store);
	private userAuthenticationService = inject(UserAuthenticationService);
	private localStorageService = inject(LocalStorageService);


	@ViewChild('bannerElement') public $bannerElement: ElementRef<HTMLElement> | undefined

	public banners: IPortalBanner[] = [];
	public banner: IPortalBanner | undefined;
	public showBanner = false;
	public active = true;

	ngOnInit(): void {


		this.store.select(portalSettingsBanner).subscribe(settings => {

			if (settings?.banner.length > 0) {
				const todayDate = new Date();

				// Set the isActive status based on the date if the status are 'published' only
				settings?.banner.forEach(banner => {
					if (banner.isActive && banner.publishStartDate && banner.publishEndDate) {
						// Date today needs to be bigger than the start date and Date today needs to be lower than the end date
						banner.isActive = (todayDate.getTime() >= new Date(banner.publishStartDate).getTime()) && (todayDate.getTime() <= new Date(banner.publishEndDate).getTime());
					}
				});

				const isAuthenticated = this.userAuthenticationService.isUserAuthenticated();
				const isLegacyUser = this.userAuthenticationService.isLegacyUser();

				// Get only the banners that are published on academy
				// Get only the banner based on the role. If the user is authenticated
				this.banners = settings?.banner.filter(x => x.isActive && (x.showToUsers.toLowerCase() === 'all' || (isAuthenticated && isLegacyUser && x.showToUsers.toLowerCase() === 'legacy') || (isAuthenticated && !isLegacyUser && x.showToUsers.toLowerCase() === 'new')));

				const key = this.localStorageService.getLocalStorageKey(LocalStorageKeyEnum.Banner)
				const currentValue: string[] = this.localStorageService.get(key)
				if(currentValue){
					this.banners = this.banners.filter(x => currentValue.find(t => t !== x.title + x.content))
				}

				// If has banners iterate over all and do changes
				if (this.banners && this.banners.length > 0) {

					if (this.banners.length > 1) {

						this.banners = this.banners.sort((a, b) => {
							const dateA = a.publishStartDate ? new Date(a.publishStartDate) : new Date(+0);
							const dateB = b.publishStartDate ? new Date(b.publishStartDate) : new Date(+0);
							return dateB.getTime() - dateA.getTime();
						});
					}

					this.banner = this.banners[0];

					setTimeout(() => {
						// Set the HTML Element props based on the config on file
						if (this.banner && this.$bannerElement) {

							// Set the Banner HTML Element props based on the config on file
							this.$bannerElement.nativeElement.style.background = this.banner?.color?.background ?? "white";
							this.$bannerElement.nativeElement.style.color = this.banner?.color?.text ?? "black";

							// Set the button close color
							const buttonClose: HTMLElement | null = this.$bannerElement.nativeElement.querySelector('.btn-icon');
							if (buttonClose) {
								buttonClose.style.color = this.banner?.color?.text ?? "black";
							}

							// Set the Button Action HTML Element props based on the config on file
							const button: HTMLElement | null = this.$bannerElement.nativeElement.querySelector('.banner-action');
							if (this.banner.action && this.banner.action && button) {
								if (this.banner.action?.color?.background) { button.style.background = this.banner.action?.color?.background; }
								if (this.banner.action?.color?.text) { button.style.color = this.banner.action?.color?.text; }
							}
						}

						setTimeout(() => {
							this.showBanner = true;
						}, 300)
					}, 300)
				}
			}
		});
	}

	public dismiss(){
		if(this.banner){
			this.active = false
			const key = this.localStorageService.getLocalStorageKey(LocalStorageKeyEnum.Banner)
			let currentValue: string[] = this.localStorageService.get(key)
			if(currentValue){
				currentValue.push(this.banner.title + this.banner.content)
			}else{
				currentValue = [this.banner.title + this.banner.content]
			}
			this.localStorageService.save(this.localStorageService.getLocalStorageKey(LocalStorageKeyEnum.Banner), currentValue)
		}
	}
}
